/*************
 * scrollTo
 * Be sure there is a container element with class js-scroll-to
 * and target container with id specified in trigger element.
 *
 * Usage:
 * <a class="js-scroll-to" href="${container-id}">
 *
 */

custom.scrollTo = (() => {
  // Constant variables
  const controller = new ScrollMagic.Controller();
  const triggerClass = 'js-scroll-to';

  function scrollToAnimation(event = null) {
    event.preventDefault();
    if (!$(event.target).attr('href')) return;

    // if there is accordion target, open it
    if ($(event.target).data('accordion-item')) {
      $el = $($(event.target).attr('href'));
      custom.Accordion.openItem($el);
    }

    // Add method to controller
    controller.scrollTo((newScrollPos) => {
      $('body, html').animate({ scrollTop: newScrollPos }, 500);
    });
    const offsetData =
      $(event.target).data('scroll-offset') !== void 0
        ? $(event.target).data('scroll-offset')
        : 0;
    const scrollY = $($(event.target).attr('href')).offset().top;
    controller.scrollTo(scrollY - offsetData);
  }

  const init = () => {
    $(`.${triggerClass}`).on('click', scrollToAnimation);
  };

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/scroll-to.js